module.exports = __webpack_public_path__ + "img/pic_bank_China@2x.ea539dc5.png";